import React from "react";
import "../styles/banner_coin.css";




const BannerCoin = ({ image, symbol, price, priceChange, nairaRate}) => {
    return (
        <div className='banner-coin'>
         
             <span><img src={image} alt='btc' /></span>
             <span style={{color:'gold'}}>{symbol.toUpperCase()}/NGN</span>
             <span>N{(price * nairaRate).toLocaleString()}</span>
             {priceChange < 0 ? 
               (<span className='red'>{parseFloat(priceChange).toFixed(2)}%</span>
              ) : 
              (<span  className='green'>{parseFloat(priceChange).toFixed(2)}%</span>)
            }
         
        </div>
    )
}

export default BannerCoin; 